import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
import { mapErrorMessage } from '../utils/maps.js';
const removeMetamaskFromErrorString = (message) => message
    .replaceAll('Rainbow', '')
    .replaceAll('RainBow', '')
    .replaceAll('Rainbow:', '');
export class RainbowWalletException extends ConcreteException {
    static errorClass = 'RainbowWalletException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        const { message } = this;
        if (message
            .trim()
            .toLowerCase()
            .includes('missing or invalid parameters'.toLowerCase())) {
            this.setMessage('Please make sure you are using Rainbow Wallet');
        }
        else {
            this.setMessage(mapErrorMessage(removeMetamaskFromErrorString(message)));
        }
        this.setName(RainbowWalletException.errorClass);
    }
}
